var _rect, _rect2, _circle, _circle2, _circle3, _rect3, _rect4, _circle4, _circle5, _circle6, _mask, _path, _path2, _rect5, _path3, _rect6, _path4, _rect7, _rect8, _rect9, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtVotingPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 121,
    viewBox: "0 0 229 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 0.5,
    width: 95,
    height: 71,
    stroke: "#E5EFF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    width: 95,
    height: 10,
    fill: "#E5EFF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 5,
    r: 2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 5,
    r: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 5,
    r: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 21.5,
    width: 139,
    height: 99,
    fill: "white",
    stroke: "#0F214F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 21,
    width: 140,
    height: 10,
    fill: "#0F214F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 26,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 26,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 26,
    r: 2,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_2137_1358",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1541 49.9996L9.58219 47.6314C8.73819 47.4206 7.91707 47.0975 7.14048 46.6612L5.09912 47.9889L2.20926 45.1795L3.47894 43.1018C3.02099 42.3383 2.67497 41.5257 2.44008 40.6882L0.0567839 40.1837L0 36.1537L2.36859 35.5818C2.57938 34.7382 2.90252 33.9163 3.33881 33.1401L2.01072 31.0987L4.81969 28.2089L6.89782 29.4789C7.66175 29.021 8.47429 28.6746 9.31175 28.4397L9.81586 26.0564L13.8459 26L14.4178 28.3678C15.2614 28.5786 16.0833 28.9017 16.8595 29.338L18.9009 28.0103L21.7907 30.8197L20.5211 32.8974C20.979 33.6609 21.3254 34.4735 21.5599 35.3109L23.9432 35.8159L24 39.8459L21.6322 40.4178C21.4206 41.2614 21.0975 42.0829 20.6616 42.8591L21.9897 44.9005L19.1803 47.7903L17.1022 46.5207C16.3387 46.9786 15.5261 47.3246 14.6887 47.5595L14.1837 49.9428L10.1541 49.9996ZM7.80432 37.8646C7.8035 38.9925 8.24143 40.12 9.11403 40.9685C9.95435 41.7851 11.0414 42.192 12.1277 42.192C13.2548 42.192 14.3802 41.7541 15.2279 40.8819C16.0437 40.0428 16.4506 38.957 16.4514 37.8719C16.4522 36.744 16.0143 35.6165 15.1417 34.768C14.3014 33.9514 13.2143 33.5445 12.1281 33.5445C11.001 33.5445 9.8751 33.9824 9.02742 34.8546C8.21161 35.6941 7.80514 36.7796 7.80432 37.8646Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58219 47.6314L10.5542 47.3967L10.4121 46.808L9.8245 46.6612L9.58219 47.6314ZM7.14048 46.6612L7.63028 45.7894L7.10262 45.4929L6.59526 45.8229L7.14048 46.6612ZM5.09912 47.9889L4.40206 48.7059L4.97477 49.2626L5.64434 48.8272L5.09912 47.9889ZM2.20926 45.1795L1.35597 44.6581L0.939435 45.3397L1.51221 45.8965L2.20926 45.1795ZM3.47894 43.1018L4.33223 43.6232L4.64792 43.1066L4.33651 42.5874L3.47894 43.1018ZM2.44008 40.6882L3.40292 40.4182L3.23943 39.8353L2.64718 39.7099L2.44008 40.6882ZM0.0567839 40.1837L-0.943117 40.1978L-0.931862 40.9966L-0.150316 41.1621L0.0567839 40.1837ZM0 36.1537L-0.234717 35.1816L-1.01115 35.3691L-0.999901 36.1678L0 36.1537ZM2.36859 35.5818L2.6033 36.5538L3.19195 36.4117L3.33876 35.8242L2.36859 35.5818ZM3.33881 33.1401L4.21054 33.6301L4.50722 33.1023L4.17703 32.5947L3.33881 33.1401ZM2.01072 31.0987L1.29365 30.4017L0.736901 30.9745L1.17251 31.644L2.01072 31.0987ZM4.81969 28.2089L5.34117 27.3556L4.65948 26.939L4.10262 27.5119L4.81969 28.2089ZM6.89782 29.4789L6.37634 30.3322L6.89281 30.6479L7.41198 30.3366L6.89782 29.4789ZM9.31175 28.4397L9.58182 29.4025L10.1648 29.239L10.2901 28.6466L9.31175 28.4397ZM9.81586 26.0564L9.80187 25.0565L9.00287 25.0677L8.83751 25.8494L9.81586 26.0564ZM13.8459 26L14.8179 25.7652L14.6304 24.9889L13.8319 25.0001L13.8459 26ZM14.4178 28.3678L13.4458 28.6026L13.5879 29.1911L14.1754 29.3379L14.4178 28.3678ZM16.8595 29.338L16.3695 30.2097L16.8972 30.5064L17.4047 30.1763L16.8595 29.338ZM18.9009 28.0103L19.5979 27.2933L19.0252 26.7365L18.3557 27.172L18.9009 28.0103ZM21.7907 30.8197L22.644 31.3411L23.0606 30.6595L22.4878 30.1027L21.7907 30.8197ZM20.5211 32.8974L19.6678 32.376L19.3521 32.8926L19.6635 33.4118L20.5211 32.8974ZM21.5599 35.3109L20.597 35.5806L20.7602 36.1637L21.3527 36.2892L21.5599 35.3109ZM23.9432 35.8159L24.9431 35.8018L24.9319 35.0031L24.1505 34.8376L23.9432 35.8159ZM24 39.8459L24.2348 40.8179L25.0112 40.6304L24.9999 39.8318L24 39.8459ZM21.6322 40.4178L21.3974 39.4458L20.8095 39.5878L20.6623 40.1745L21.6322 40.4178ZM20.6616 42.8591L19.7897 42.3695L19.4933 42.8972L19.8234 43.4044L20.6616 42.8591ZM21.9897 44.9005L22.7067 45.5975L23.2635 45.0247L22.8279 44.3551L21.9897 44.9005ZM19.1803 47.7903L18.6589 48.6437L19.3406 49.0601L19.8973 48.4874L19.1803 47.7903ZM17.1022 46.5207L17.6235 45.6673L17.107 45.3517L16.5878 45.6631L17.1022 46.5207ZM14.6887 47.5595L14.4186 46.5967L13.8358 46.7601L13.7104 47.3523L14.6887 47.5595ZM14.1837 49.9428L14.1978 50.9427L14.9965 50.9315L15.162 50.1501L14.1837 49.9428ZM9.11403 40.9685L8.41689 41.6854L8.4171 41.6856L9.11403 40.9685ZM15.2279 40.8819L14.5109 40.1848L14.5108 40.1849L15.2279 40.8819ZM16.4514 37.8719L17.4514 37.8727V37.8727L16.4514 37.8719ZM15.1417 34.768L15.8388 34.0511L15.8386 34.0509L15.1417 34.768ZM9.02742 34.8546L8.31031 34.1577L8.31027 34.1577L9.02742 34.8546ZM11.1262 49.7648L10.5542 47.3967L8.61013 47.8662L9.18206 50.2343L11.1262 49.7648ZM9.8245 46.6612C9.06582 46.4717 8.32806 46.1814 7.63028 45.7894L6.65068 47.533C7.50608 48.0136 8.41056 48.3695 9.33987 48.6016L9.8245 46.6612ZM6.59526 45.8229L4.5539 47.1506L5.64434 48.8272L7.6857 47.4995L6.59526 45.8229ZM5.79617 47.2718L2.90632 44.4625L1.51221 45.8965L4.40206 48.7059L5.79617 47.2718ZM3.06255 45.7009L4.33223 43.6232L2.62565 42.5803L1.35597 44.6581L3.06255 45.7009ZM4.33651 42.5874C3.92532 41.9018 3.61426 41.1717 3.40292 40.4182L1.47723 40.9583C1.73568 41.8797 2.11666 42.7747 2.62136 43.6161L4.33651 42.5874ZM2.64718 39.7099L0.263884 39.2054L-0.150316 41.1621L2.23298 41.6666L2.64718 39.7099ZM1.05668 40.1696L0.999901 36.1396L-0.999901 36.1678L-0.943117 40.1978L1.05668 40.1696ZM0.234717 37.1258L2.6033 36.5538L2.13387 34.6097L-0.234717 35.1816L0.234717 37.1258ZM3.33876 35.8242C3.52831 35.0656 3.81872 34.3271 4.21054 33.6301L2.46709 32.6501C1.98632 33.5054 1.63045 34.4108 1.39841 35.3394L3.33876 35.8242ZM4.17703 32.5947L2.84894 30.5534L1.17251 31.644L2.5006 33.6854L4.17703 32.5947ZM2.72779 31.7957L5.53676 28.9059L4.10262 27.5119L1.29365 30.4017L2.72779 31.7957ZM4.29821 29.0621L6.37634 30.3322L7.4193 28.6257L5.34117 27.3556L4.29821 29.0621ZM7.41198 30.3366C8.09833 29.9252 8.82862 29.6138 9.58182 29.4025L9.04169 27.4768C8.11996 27.7354 7.22516 28.1168 6.38366 28.6212L7.41198 30.3366ZM10.2901 28.6466L10.7942 26.2633L8.83751 25.8494L8.3334 28.2327L10.2901 28.6466ZM9.82985 27.0563L13.8599 26.9999L13.8319 25.0001L9.80187 25.0565L9.82985 27.0563ZM12.8738 26.2348L13.4458 28.6026L15.3899 28.133L14.8179 25.7652L12.8738 26.2348ZM14.1754 29.3379C14.934 29.5275 15.6725 29.8179 16.3695 30.2097L17.3495 28.4663C16.4942 27.9855 15.5888 27.6296 14.6602 27.3976L14.1754 29.3379ZM17.4047 30.1763L19.4461 28.8486L18.3557 27.172L16.3143 28.4997L17.4047 30.1763ZM18.2038 28.7273L21.0937 31.5367L22.4878 30.1027L19.5979 27.2933L18.2038 28.7273ZM20.9374 30.2983L19.6678 32.376L21.3744 33.4188L22.644 31.3411L20.9374 30.2983ZM19.6635 33.4118C20.0748 34.0976 20.3861 34.8277 20.597 35.5806L22.5229 35.0413C22.2647 34.1193 21.8832 33.2243 21.3786 32.383L19.6635 33.4118ZM21.3527 36.2892L23.736 36.7941L24.1505 34.8376L21.7672 34.3326L21.3527 36.2892ZM22.9433 35.8299L23.0001 39.86L24.9999 39.8318L24.9431 35.8018L22.9433 35.8299ZM23.7652 38.8738L21.3974 39.4458L21.867 41.3899L24.2348 40.8179L23.7652 38.8738ZM20.6623 40.1745C20.4719 40.9336 20.1813 41.6721 19.7897 42.3695L21.5335 43.3488C22.0137 42.4937 22.3694 41.5892 22.6022 40.6611L20.6623 40.1745ZM19.8234 43.4044L21.1515 45.4458L22.8279 44.3551L21.4998 42.3138L19.8234 43.4044ZM21.2727 44.2034L18.4633 47.0933L19.8973 48.4874L22.7067 45.5975L21.2727 44.2034ZM19.7017 46.937L17.6235 45.6673L16.5808 47.374L18.6589 48.6437L19.7017 46.937ZM16.5878 45.6631C15.9023 46.0743 15.1721 46.3853 14.4186 46.5967L14.9587 48.5224C15.8802 48.2639 16.7751 47.8829 17.6165 47.3782L16.5878 45.6631ZM13.7104 47.3523L13.2054 49.7355L15.162 50.1501L15.6669 47.7668L13.7104 47.3523ZM14.1696 48.9429L10.14 48.9997L10.1682 50.9995L14.1978 50.9427L14.1696 48.9429ZM6.80432 37.8639C6.80332 39.2509 7.34261 40.6408 8.41689 41.6854L9.81116 40.2516C9.14026 39.5992 8.80369 38.7341 8.80432 37.8653L6.80432 37.8639ZM8.4171 41.6856C9.45136 42.6907 10.7915 43.192 12.1277 43.192V41.192C11.2913 41.192 10.4573 40.8795 9.81095 40.2513L8.4171 41.6856ZM12.1277 43.192C13.5138 43.192 14.9015 42.6526 15.945 41.5788L14.5108 40.1849C13.859 40.8556 12.9957 41.192 12.1277 41.192V43.192ZM15.9449 41.579C16.9492 40.546 17.4504 39.2073 17.4514 37.8727L15.4514 37.8712C15.4508 38.7066 15.1383 39.5395 14.5109 40.1848L15.9449 41.579ZM17.4514 37.8727C17.4524 36.4856 16.9131 35.0957 15.8388 34.0511L14.4446 35.485C15.1155 36.1373 15.452 37.0024 15.4514 37.8712L17.4514 37.8727ZM15.8386 34.0509C14.8044 33.0458 13.4642 32.5445 12.1281 32.5445V34.5445C12.9644 34.5445 13.7984 34.857 14.4448 35.4852L15.8386 34.0509ZM12.1281 32.5445C10.742 32.5445 9.35393 33.0839 8.31031 34.1577L9.74453 35.5516C10.3963 34.881 11.2599 34.5445 12.1281 34.5445V32.5445ZM8.31027 34.1577C7.30609 35.1911 6.80533 36.5293 6.80432 37.8638L8.80432 37.8653C8.80495 37.0298 9.11714 36.1972 9.74458 35.5515L8.31027 34.1577Z",
    fill: "#0F214F",
    mask: "url(#path-11-inside-1_2137_1358)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5091 76.4755L34.044 72.4418C32.6907 71.9217 31.398 71.2204 30.2019 70.3409L26.5553 72.1226L22.3454 66.8882L24.8678 63.709C24.2653 62.353 23.858 60.9386 23.6395 59.5055L19.7994 58.1868L20.5241 51.5086L24.5584 51.0436C25.0785 49.6909 25.78 48.3969 26.6594 47.2015L24.877 43.5548L30.1107 39.3449L33.2905 41.868C34.6472 41.2656 36.0617 40.8576 37.4948 40.6391L38.8128 36.7989L45.4909 37.5242L45.9561 41.5573C47.3088 42.0773 48.6028 42.7788 49.7982 43.6582L53.4448 41.8765L57.6547 47.1109L55.1323 50.2901C55.7348 51.6461 56.1428 53.0606 56.3606 54.4936L60.2006 55.813L59.476 62.4912L55.4429 62.9563C54.9215 64.3088 54.2201 65.6022 53.3414 66.7977L55.1237 70.4444L49.8894 74.6542L46.7095 72.1318C45.3535 72.7343 43.939 73.1416 42.506 73.3601L41.1866 77.2001L34.5091 76.4755ZM33.0868 55.924C32.8563 57.7897 33.3518 59.7438 34.6229 61.3246C35.8471 62.8462 37.5628 63.7401 39.3597 63.9607C41.2242 64.1897 43.1749 63.6938 44.7543 62.4232C46.2743 61.2008 47.168 59.4872 47.3897 57.6925C47.6201 55.8268 47.1247 53.8727 45.8536 52.2919C44.6293 50.7703 42.9137 49.8764 41.1168 49.6558C39.2523 49.4268 37.3009 49.9226 35.7215 51.1932C34.2014 52.4163 33.3085 54.1293 33.0868 55.924Z",
    fill: "#77DDFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 48.5,
    width: 23,
    height: 23,
    stroke: "#0F214F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.75 57.3859L108.929 55.5L102.89 61.7534L100.071 58.8339L98.25 60.7198L102.89 65.5L110.75 57.3859Z",
    fill: "#0F214F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 79,
    width: 24,
    height: 24,
    fill: "#0F214F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104 97.3125C107.21 97.3125 109.812 94.7101 109.812 91.5C109.812 88.2899 107.21 85.6875 104 85.6875C100.79 85.6875 98.1875 88.2898 98.1875 91.5C98.1875 94.7101 100.79 97.3125 104 97.3125ZM107.534 93.9733L101.527 87.966C103.172 86.8092 105.516 86.9175 107.049 88.4506C108.583 89.9845 108.69 92.329 107.534 93.9733ZM100.466 89.0266C99.31 90.6709 99.4167 93.0155 100.951 94.5494C102.484 96.0825 104.828 96.1907 106.473 95.034L100.466 89.0266Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 79.5,
    width: 23,
    height: 23,
    stroke: "#0F214F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 90,
    width: 10,
    height: 3,
    fill: "#0F214F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 48.5,
    width: 23,
    height: 23,
    stroke: "#0F214F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.5 62.5454L132.295 66.75L130.25 64.7046L134.455 60.5L130.25 56.2954L132.295 54.25L136.5 58.4546L140.705 54.25L142.75 56.2954L138.545 60.5L142.75 64.7046L140.705 66.75L136.5 62.5454Z",
    fill: "#0F214F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197 110H223C226.314 110 229 107.314 229 104V84C229 80.6863 226.314 78 223 78H203C199.686 78 197 80.6863 197 84V110Z",
    fill: "#77DDFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2137_1358",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 78,
    width: 32,
    height: 32
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197 110H223C226.314 110 229 107.314 229 104V84C229 80.6863 226.314 78 223 78H203C199.686 78 197 80.6863 197 84V110Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2137_1358)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219 104H222.868V101H219V104Z",
    fill: "#46B1DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.795 87.8926H222.663V84.8926H218.795V87.8926Z",
    fill: "#46B1DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219 92H222.868V89H219V92Z",
    fill: "#0F214F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219 96H222.868V93H219V96Z",
    fill: "#46B1DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219 100H222.868V97H219V100Z",
    fill: "#0F214F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214 104H217.868V101H214V104Z",
    fill: "#46B1DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214 100H217.868V97H214V100Z",
    fill: "#0F214F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209 104H212.868V101H209V104Z",
    fill: "#46B1DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209 92H212.868V89H209V92Z",
    fill: "#46B1DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209 96H212.868V93H209V96Z",
    fill: "#0F214F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209 100H212.868V97H209V100Z",
    fill: "#46B1DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204 104H207.868V101H204V104Z",
    fill: "#46B1DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204 100H207.868V97H204V100Z",
    fill: "#0F214F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtVotingPower);
export default __webpack_public_path__ + "static/media/art-voting-power.fa541b5efab167a5c225f01933011848.svg";
export { ForwardRef as ReactComponent };